import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import Pagination from 'components/molecules/pagination';
import withLoaderTable from 'components/organisms/withLoader/withLoaderTable';
import ManualInteractionTimeItem from './manualInteractionTimeItem';

const ManualInteractionTimes = ({ patientGuid }) => {
  const loading = useSelector(
    (state) =>
      state.loading.effects.manualInteractiveTime.getManualInteractionTimes,
  );
  const manualInteractionTimes = useSelector(
    (state) => state.manualInteractiveTime,
  );
  const {
    manualInteractiveTime: {
      getManualInteractionTimes,
      setPage: setManualInteractionTimesPage,
    },
  } = useDispatch();

  useEffect(() => {
    getManualInteractionTimes(patientGuid);
  }, [patientGuid]);

  const setPage = (pageOffset) => {
    const { page } = manualInteractionTimes;
    setManualInteractionTimesPage(page + pageOffset);
    getManualInteractionTimes(patientGuid);
  };

  return (
    <div className="general-comments">
      <Table
        className="general-comments-table"
        borderless
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <thead>
          <tr>
            <th colSpan="3">
              <Pagination
                title="Manual Clinical Note"
                page={manualInteractionTimes.page}
                total={manualInteractionTimes.totalCount}
                itemsPerPage={manualInteractionTimes.pageStep}
                pageTotal={manualInteractionTimes.data.length}
                handlePrevClick={() => setPage(-1)}
                handleNextClick={() => setPage(+1)}
                handleFirstClick={() =>
                  setPage(-(manualInteractionTimes.page - 1))
                }
                handleLastClick={() =>
                  setPage(
                    Math.ceil(
                      manualInteractionTimes.totalCount /
                        manualInteractionTimes.pageStep,
                    ) - manualInteractionTimes.page,
                  )
                }
                loading={loading}
              />
            </th>
          </tr>
        </thead>

        {withLoaderTable(
          loading,
          <tbody>
            {manualInteractionTimes.data.map((manualInteractionTime, index) => (
              <ManualInteractionTimeItem
                key={index + 1}
                id={index + 1}
                manualInteractionTime={manualInteractionTime}
              />
            ))}
          </tbody>,
        )}
      </Table>
    </div>
  );
};

ManualInteractionTimes.propTypes = {
  patientGuid: PropTypes.string.isRequired,
};

export default ManualInteractionTimes;
